module.exports = __webpack_public_path__ + "148d6a2535c91c0c7922e03abc865cec.svg";